module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Company Selector")]), _vm._v(" "), _c('el-input', {
    ref: "search",
    attrs: {
      "placeholder": "Search...",
      "prefix-icon": "el-icon-search",
      "autofocus": true
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', _vm._l((_vm.filteredItems), function(company) {
    return _c('tr', {
      key: company.id,
      on: {
        "click": function($event) {
          return _vm.switchCompany(company)
        }
      }
    }, [_c('td', [_c('a', [_vm._v(_vm._s(company.title))])])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-444b2ed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/company/CompanySelector.vue
// module id = 3253
// module chunks = 3